import {useSubscription} from '../../../providers/subscription/useSubscription.ts'
import {useConnections} from '../../../providers/connections/useConnections.ts'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../../routes.ts'
import {validAmountOfConnectionsForTier} from '@package/shared'
import {SubscriptionErrorBanner} from './SubscriptionErrorBanner.tsx'

export const TooManyConnectionsErrorBanner = () => {
  const navigate = useNavigate()
  const {activeSubscriptionTier, loading: loadingSubscriptions} = useSubscription()
  const {connections, loading: loadingConnections} = useConnections()

  if (loadingSubscriptions || loadingConnections) return null

  if (activeSubscriptionTier.tier === 'none') return null

  if (validAmountOfConnectionsForTier(activeSubscriptionTier, connections)) return null

  return (
    <SubscriptionErrorBanner
      title={'Recommendation creation disabled'}
      buttons={[
        {
          title: 'Manage connections',
          onClick: () => navigate(routes.connections.buildRoute()),
        },
      ]}
    >
      You have too many active connections for your current subscription!
    </SubscriptionErrorBanner>
  )
}
